/**
 * API helper — all backend calls go through this to ensure a single
 * source of truth for REACT_APP_BACKEND_URL usage.
 */

const BASE = process.env.REACT_APP_BACKEND_URL;

if (!BASE) {
  // eslint-disable-next-line no-console
  console.warn('[api] REACT_APP_BACKEND_URL is not set — API calls will fail.');
}

export async function submitContact(payload) {
  const res = await fetch(`${BASE}/api/contacts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.details = data.details || [];
    throw err;
  }
  return data;
}
